import { apiGet } from './apiClient';
import { API_ROUTES } from './apiRoutes';

const UNLIMITED_THRESHOLD = 999999;

let plansPromise = null;

export async function fetchPublicPlans() {
  if (!plansPromise) {
    plansPromise = apiGet(API_ROUTES.public.plans, { auth: false })
      .then((data) => data?.plans || [])
      .catch((error) => {
        plansPromise = null;
        throw error;
      });
  }

  return plansPromise;
}

export function findPlan(plans, slug) {
  return (plans || []).find((plan) => plan.slug === slug) || null;
}

export function isUnlimited(value) {
  return Number(value || 0) >= UNLIMITED_THRESHOLD;
}

export function formatPlanPrice(plan, billingCycle = 'monthly') {
  if (!plan) return null;
  const amount = billingCycle === 'yearly' ? plan.priceYearly : plan.priceMonthly;
  if (amount === undefined || amount === null) return null;
  if (Number(amount) === 0) {
    return billingCycle === 'yearly' ? '$0/year' : '$0/forever';
  }
  return billingCycle === 'yearly' ? `$${amount}/year` : `$${amount}/month`;
}

export function formatAccountsLabel(plan) {
  if (!plan) return 'Account limits from your active plan';
  if (isUnlimited(plan.maxAccounts)) return 'Unlimited MT4/MT5 accounts';
  return `Up to ${plan.maxAccounts} MT4/MT5 accounts`;
}

export function formatApiKeysLabel(plan) {
  if (!plan) return 'API key limits from your active plan';
  return `${plan.maxApiKeys} API keys`;
}

export function formatRetentionLabel(plan) {
  if (!plan) return 'Data retention based on your active plan';
  if (isUnlimited(plan.dataRetentionDays)) return 'Unlimited data retention';
  return `${plan.dataRetentionDays}-day data retention`;
}

export function primaryFeatureSummary(plan) {
  if (!plan?.features) return 'core tracking features';

  const premiumFeatures = [];
  if (plan.features.monteCarlo) premiumFeatures.push('Monte Carlo');
  if (plan.features.pdfReports) premiumFeatures.push('PDF reports');
  if (plan.features.brokerComparison) premiumFeatures.push('broker comparison');

  if (!premiumFeatures.length) return 'core tracking features';
  return `${premiumFeatures.join(', ')}, and more`;
}

export function formatPlanSummary(plan) {
  if (!plan) return 'plan details sync from the backend pricing catalog';
  return `${formatAccountsLabel(plan)}, ${formatApiKeysLabel(plan)}, ${primaryFeatureSummary(plan)}`;
}
